
import { Vue, Component } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import {
  customBreakpointIcon,
  DEVICE_ICONS
} from "@/lib/breakpoints/breakpoints";
import { uiStore } from "@/store/store";

@Component({
  components: { Icon }
})
export default class OxyClassBreakpointIcon extends Vue {
  get currentBreakpointId() {
    return uiStore.currentBreakpoint.id;
  }

  get breakpointIcon() {
    return DEVICE_ICONS[this.currentBreakpointId]?.icon || customBreakpointIcon;
  }

  get breakpointIconRotation() {
    return DEVICE_ICONS[this.currentBreakpointId]?.rotate;
  }
}
